import React from 'react';
import styled from 'styled-components';
import { ArrowUpOutlined } from '@ant-design/icons';

const RotateWrapper = styled.span<{ degrees: number }>`
    svg {
        transform: rotate(${({ degrees }) => degrees}deg);
    }
`;

interface ArrowProps {
    degrees?: number;
}

const Arrow: React.FC<ArrowProps> = ({ degrees = 0 }) => (
    <RotateWrapper degrees={degrees}>
        <ArrowUpOutlined />
    </RotateWrapper>
);

export default Arrow;
